import {onFind} from "@elements/init-modules-in-scope";
import {findAllIn, addClass} from "@elements/dom-utils";
import {onEnterViewPort} from "@elements/viewport-utils";

export function init (offset = 0) {
    // window.addEventListener('load', () => {
        onFind('.js-viewport-animation-trigger', (baseElement) => {
            onEnterViewPort(baseElement, () => {
                const startClass = baseElement.getAttribute('data-viewport-animation-trigger-class');

                if (startClass) {
                        addClass(startClass, baseElement);
                }
            }, {offset: offset});
        });
    // });
}